module.exports = __webpack_public_path__ + "static/media/daylin.09a87f6a.webp";